import axios from 'axios';
import baseUrl from './config';

const defaultError = {
  code: 500,
  status: 'error',
  message: 'Failed to fetch data. Please contact developer.'
};

const CancelToken = axios.CancelToken;

let cancel = {};

export const fetch = ({...opt}) => {
  if (cancel[opt.url] !== undefined) {
    cancel[opt.url]();
  }

  const options = {
    baseURL: baseUrl,
    cancelToken: new CancelToken(function executor(c) {
      cancel[opt.url] = c;
    }),
    ...opt
  };

  return new Promise((resolve, reject) => {
    axios(options)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          // do nothing
        } else if (typeof err.response === 'undefined') {
          reject(defaultError);
        } else if (typeof err.response.data === 'undefined') {
          reject(defaultError);
        } else {
          reject(err.response.data);
        }
      });
  });
};